import { styled, TextField as BaseTextField } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'

const INPUT_HEIGHT = 30
const ICON_SIZE = 26
const HELPER_TEXT_HEIGHT = 0
const HELPER_TEXT_BOTTOM = 0
const HELPER_TEXT_LEFT = -10

export const TextField = styled(BaseTextField)({
  display: 'flex',
  '& .MuiInputBase-root': {
    height: INPUT_HEIGHT,
  },
  '& .MuiFormHelperText-contained': {
    position: 'absolute',
    bottom: HELPER_TEXT_BOTTOM,
    left: HELPER_TEXT_LEFT,
    height: HELPER_TEXT_HEIGHT,
  },
  '& fieldset': {
    top: 0,
  },
  '& > p': {
    lineHeight: 1.2,
  },
})

export const Icon = styled(IconButton)(({ theme }) => ({
  alignSelf: 'center',
  color: theme.palette.primary.main,
  borderRadius: '50%',
  '& svg': {
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
}))
